var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center justify-center"},[_c('v-btn',{attrs:{"color":"primary","x-large":""},on:{"click":_vm.saveAction}},[_vm._v(" Save ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }